










































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'company_recruitments'
    
    data: ()->
        loading: true
        alert: false
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        recruitments: []

    computed:
        data_filtered: ()->
            self = @
            data = @recruitments.filter (x) ->
                !self.search || x.job.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.job.name.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        has_mutation_right: ()->
            return @has_access_right('recruitments_edit')

        has_deletion_right: ()->
            return @has_access_right('recruitments_delete')

        doc_url: ()->
            # console.log "DOCURL ", settings.document_url
            return settings.document_url

    methods:
        has_access_right: t.has_access_right

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            if prop == 'job.name'
                @recruitments.sort (a,b)->
                    modifier = 1
                    if order == 'descending'
                        modifier = -1
                    return a['job']['name'].toLowerCase().localeCompare(b['job']['name'].toLowerCase())*modifier
            else
                @recruitments.sort (a,b)->
                    modifier = 1
                    if order == 'descending'
                        modifier = -1
                    if a[prop] < b[prop]
                        return -1 * modifier
                    if a[prop] > b[prop]
                        return 1 * modifier
                    return 0
            # console.log "RECRUITMENTS SORT ", @recruitments

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        active_title: (is_active)->
            title = "Activer"
            if is_active
                title = "Clore"
            return title

        get_recruitments: ()->
            self = @
            @loading = true
            q.run('get_recruitment_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_recruitments: get_recruitments: then", e.message)
                else
                    # console.log "GET recruitments : ", resp.body.data.recruitment_set
                    for r in resp.body.data.recruitment_set
                        if r.content?
                            r.content = r.content.replace(/\n/g, '\n')
                        if r.experience_level == null
                            r.experience_level = {uid:''}
                        if r.graduate_level == null
                            r.graduate_level = {uid:''}
                        if r.status == null
                            r.status = {uid:''}
                    self.recruitments = resp.body.data.recruitment_set
                    self.loading = false
                    if self.recruitments.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "company_recruitments: get_recruitments()")

        change_active: (index)->
            # console.log "CHANGE ACTIVE", index
            active_recruitment = @recruitments[index]
            if active_recruitment.active == 0
                active_recruitment.active = 1
            else
                active_recruitment.active = 0
            active_recruitment['job_uid'] = active_recruitment.job.uid
            self = @
            m.run('save_recruitment', [active_recruitment])
            .then (resp)->
                if resp.body.data.recruitment_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.recruitment_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.recruitment_form_mutation.errors
                    for e in resp.body.data.recruitment_form_mutation.errors
                        n.gql_error("company_recruitments: change_active: then", e.messages)
                else
                    self.errors = {}
                    self.get_recruitments()
            .catch (resp)->
                n.catch_error(resp, "company_recruitments: change_active()")

        delete_recruitment: (recruitment_uid)->
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer ce recrutement ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "RECRUT DELETE"
                    m.run('delete_object', ["recruitment", recruitment_uid])
                    .then (resp)->
                        # console.log "DELETE RECRUT", resp.body.data.recruitment_deletion
                        if resp.body.data.recruitment_deletion.ok
                            n.success()
                            self.get_recruitments()
                        else
                            n.gql_error("company_recruitments: delete_recruitment: then", resp.body.data.recruitment_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "company_recruitments: delete_recruitment()")
        
    beforeMount: ()->
        @get_recruitments()
}
